/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=Common&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=Common&lang=js"

import "./index.vue?vue&type=style&index=0&id=164c8ebd&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-164c8ebd"]])

export default __exports__